import React, { createContext, useContext, useState } from 'react';

const FundamentalsSelectionContext = createContext();

export const useFundamentalsSelection = () => useContext(FundamentalsSelectionContext);

export const FundamentalsSelectionProvider = ({ children }) => {
    const [selectedButtons, setSelectedButtons] = useState({
        peRatio: false,
        roic: false,
        revenueGrowth: false,
        netIncomeGrowth: false,
        sharesOutstanding: false,
        ltlToFcf: false,
        cashFlowGrowth: false,
        priceToFcf: false,
    });

    const toggleButtonSelection = (buttonKey) => {
        setSelectedButtons((prevSelectedButtons) => ({
            ...prevSelectedButtons,
            [buttonKey]: !prevSelectedButtons[buttonKey],
        }));
    };

    return (
        <FundamentalsSelectionContext.Provider value={{ selectedButtons, toggleButtonSelection }}>
            {children}
        </FundamentalsSelectionContext.Provider>
    );
};
